import { useLocation } from 'react-router-dom';

const parseDisplayName = (param: string) =>
  param.substring(param.lastIndexOf('(as="') + 5, param.lastIndexOf('")'));

const parseParam = (param: string) => {
  const parsedDisplayName = parseDisplayName(param);
  const attribute = param.replace(`(as="${parsedDisplayName}")`, '');

  const displayName = parsedDisplayName === attribute ? '' : parsedDisplayName;
  return { attribute, displayName };
};

const useAttributeSearchParams = () => {
  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  return queryString.get('attributes')?.split(',').map(parseParam);
};

export default useAttributeSearchParams;
